import { useTranslation } from "react-i18next";
import { MenuPanel } from "./MenuPanel";

export function MobileMenuOverlay({ onClose, handleSignOut, guidePath }) {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 z-40 md:hidden">
      <button
        type="button"
        className="absolute inset-0 bg-greyscale-2/20"
        aria-label={t("navBar.closeMenu", "Close menu")}
        onClick={onClose}
      />

      <div className="absolute inset-x-0 bottom-0 bg-container p-4 pb-20 animate-[slideUp_0.25s_ease-out] border-t border-greyscale-3">
        <MenuPanel
          onClose={onClose}
          handleSignOut={handleSignOut}
          guidePath={guidePath}
        />
      </div>

      <style>{`
        @keyframes slideUp {
          from { transform: translateY(100%); }
          to   { transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
